export class EncryptionKeysStore {
    static createInMemory() {
        return new InmemoryEncryptionKeysStore();
    }
    static createSessionStorage() {
        return new SessionStorageEncryptionKeysStore();
    }
    static createLocalStorage() {
        return new LocalStorageEncryptionKeysStore();
    }
}
class InmemoryEncryptionKeysStore extends EncryptionKeysStore {
    constructor() {
        super(...arguments);
        this.keys = {};
    }
    get(subject) {
        var _a;
        return (_a = this.keys[subject.toString()]) !== null && _a !== void 0 ? _a : null;
    }
    save(subject, keys) {
        this.keys[subject.toString()] = keys;
        return keys;
    }
}
class SessionStorageEncryptionKeysStore extends EncryptionKeysStore {
    get(subject) {
        const key = createStorageKey(subject.toString());
        try {
            const keys = sessionStorage.getItem(key);
            if (!keys) {
                return null;
            }
            return deserializeDiffeHellmanKeys(keys);
        }
        catch {
            sessionStorage.removeItem(key);
            return null;
        }
    }
    save(subject, keys) {
        sessionStorage.setItem(createStorageKey(subject.toString()), serializeDiffeHellmanKeys(keys));
        return keys;
    }
}
class LocalStorageEncryptionKeysStore extends EncryptionKeysStore {
    get(subject) {
        const key = createStorageKey(subject.toString());
        try {
            const keys = localStorage.getItem(key);
            if (!keys) {
                return null;
            }
            return deserializeDiffeHellmanKeys(keys);
        }
        catch {
            localStorage.removeItem(key);
            return null;
        }
    }
    save(subject, keys) {
        localStorage.setItem(createStorageKey(subject.toString()), serializeDiffeHellmanKeys(keys));
        return keys;
    }
}
// #region json storage
const storageEncryptionKeysPrefix = 'dialect-encryption-keys';
function createStorageKey(subject) {
    return `${storageEncryptionKeysPrefix}-${subject}`;
}
export function serializeDiffeHellmanKeys(keys) {
    const toSerialize = {
        version: 1,
        keys: {
            publicKey: Array.from(keys.publicKey),
            secretKey: Array.from(keys.secretKey),
        },
    };
    return JSON.stringify(toSerialize);
}
export function deserializeDiffeHellmanKeys(data) {
    const deserialized = JSON.parse(data);
    return {
        publicKey: Uint8Array.from(deserialized.keys.publicKey),
        secretKey: Uint8Array.from(deserialized.keys.secretKey),
    };
}
// #endregion
//# sourceMappingURL=encryption-keys-store.js.map